<template>
  <div class="kaihu-new">
    <kaihu-cmb :org-info="userCurrentOrg" :user-id="userId" @success="handleSuccess"></kaihu-cmb>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { KaihuCmb } from 'zgkaihu'

export default {
  name: 'AccountKaihuCmb',
  components: {
    KaihuCmb
  },
  computed: {
    ...mapState('user', ['userId', 'userCurrentOrg'])
  },
  methods: {
    handleSuccess(orgEnterId) {
      this.$store.dispatch('tagsView/delView', { path: '/account/kaihu-cmb' })
      this.$router.push({
        name: 'AccountKaihuResult',
        query: { id: orgEnterId }
      })
    }
  }
}
</script>
